import axios from 'src/axios'
import { YOURLISTROUTES } from 'src/router/Api'

export interface LmbListingParams {
  page?: number
  limit?: number
  status?: string | string[]
  location?: string
  query?: string
  categories?: string[]
  sort?: string
  [key: string]: any
}

export const getLmbCmsListings = async (params: LmbListingParams) => {
  return await axios.get(YOURLISTROUTES.lmbListing.cms.listings, { params })
}

export const getLmbCmsStatistics = async () => {
  return await axios.get(YOURLISTROUTES.lmbListing.cms.statistics)
}

export const archiveLmbListing = async (id: string) => {
  return await axios.put(YOURLISTROUTES.lmbListing.cms.archive(id))
}

export const deleteLmbListing = async (id: string) => {
  return await axios.delete(YOURLISTROUTES.lmbListing.cms.item(id))
}